export default class Paginator {

  constructor() {
    this.data = []
  }

}